import React, { useState } from 'react';
import { DataStore } from '@aws-amplify/datastore';
import User from '../../../models/User'; // Adjust path to match your models
import questionnaireData from '../../../data/Questionnaire.json'; // Adjust path to match your JSON

function Questionnaire({ userID }) {
  const [responses, setResponses] = useState({});
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  const currentQuestion = questionnaireData[currentQuestionIndex];

  const handleOptionChange = (questionId, answer) => {
    setResponses((prevResponses) => ({
      ...prevResponses,
      [questionId]: answer,
    }));
  };

  const saveResponses = async () => {
    const user = await DataStore.query(User, userID);
    if (user) {
      await DataStore.save(
        User.copyOf(user, (updated) => {
          updated.yearOfStudy = responses[1];
          updated.medicalUniversity = responses[2];
          updated.demographics = responses[3];
          updated.username = responses[4];
          updated.completedQuestionnaire = true;
        })
      );
      alert('Responses saved successfully!');
    }
  };

  const nextQuestion = () => {
    if (currentQuestionIndex < questionnaireData.length - 1) {
      setCurrentQuestionIndex((prev) => prev + 1);
    } else {
      saveResponses();
    }
  };

  const previousQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex((prev) => prev - 1);
    }
  };

  return (
    <div className="questionnaire-container">
      <div className="questionnaire-progress">
        <div
          className="progress-bar"
          style={{
            width: `${((currentQuestionIndex + 1) / questionnaireData.length) * 100}%`,
          }}
        ></div>
      </div>

      <div className="questionnaire-question">
        <h3>{currentQuestion.question}</h3>
        {currentQuestion.options.length > 0 ? (
          <ul>
            {currentQuestion.options.map((option) => (
              <li key={option}>
                <label>
                  <input
                    type="radio"
                    name={`question-${currentQuestion.id}`}
                    value={option}
                    checked={responses[currentQuestion.id] === option}
                    onChange={() => handleOptionChange(currentQuestion.id, option)}
                  />
                  {option}
                </label>
              </li>
            ))}
          </ul>
        ) : (
          <input
            type="text"
            value={responses[currentQuestion.id] || ''}
            onChange={(e) => handleOptionChange(currentQuestion.id, e.target.value)}
          />
        )}
      </div>

      <div className="questionnaire-navigation">
        {currentQuestionIndex > 0 && (
          <button onClick={previousQuestion}>Previous</button>
        )}
        <button onClick={nextQuestion}>
          {currentQuestionIndex < questionnaireData.length - 1 ? 'Next' : 'Submit'}
        </button>
      </div>
    </div>
  );
}

export default Questionnaire;
